import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";

export default function Card() {
  return (
    <Section className="bg-beige md:mt-12 mt-8" id="culture">
      <div className="relative lg:max-w-[1101px] w-full mx-auto lg:h-[30vw] md:h-[300px] h-[250px]">
        <Image
          src="/images/day-zero@3x.webp"
          alt="Day Zero with Chalk Studio"
          fill
          sizes="(max-width: 479px) 479px,(max-width: 767px) 767px,(max-width: 991px) 991px, 1440px"
          className="w-full object-cover object-center"
        />
        <div className="absolute md:top-4 top-2 md:left-4 left-2 md:text-base text-sm text-[#f6f5f1]/70 font-havletica">
          Day Zero with Chalk Studio
        </div>
      </div>
      <div className="flex flex-col items-center gap-2 lg:max-w-[535px] w-full mx-auto md:mt-7 mt-5">
        <h2 className="capitalize text-xl md:text-2xl text-darkGrey/80 font-havletica font-light text-center">
          “Join us for a ‘Day Zero’ and experience the beginning of something
          extraordinary.
        </h2>
        <p className="text-darkGrey/70 font-light text-center text-sm">
          In our company the “Day Zero” is about setting the stage for a
          successful partnership by ensuring everyone is on the same page and
          ready to embark on a new journey together.
        </p>
      </div>
    </Section>
  );
}
